import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login'
import Home from '@/components/Home'
import Profile from '@/components/Profile'
import Dashboard from '@/components/Dashboard'
import Courses from '@/components/Courses'
import Certificate from '@/components/Certificate'
import Admin from '@/components/Admin'

import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: { auth: true }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: { auth: true }
    },
    {
      path: '/courses',
      name: 'Courses',
      component: Courses,
      meta: { auth: true }
    },
    {
      path: '/verify/:id',
      name: 'Verify',
      component: Certificate
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      meta: { auth: true }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { guest: true }
    },
    {
      path: '/',
      name: 'Home',
      component: Certificate
    }
  ]
})

const getCurrentUser = () =>
  new Promise((resolve, reject) => {
    const unsub = firebase.auth().onAuthStateChanged(
      user => {
        unsub()
        resolve(user)
      },
      reject
    )
  })

router.beforeEach(async (to, from, next) => {
  try {
    const needsAuth = to.matched.some(r => r.meta.auth)
    const isGuestOnly = to.matched.some(r => r.meta.guest)

    const user = await getCurrentUser()

    if (needsAuth) {
      if (!user) return next({ path: '/login' })

      const snap = await firebase
        .firestore()
        .collection('privileges')
        .doc(user.uid)
        .get()

      const p = snap.exists ? snap.data() : {}

      if (p.admin || p.manager || p.editor) {
        return next()
      } else {
        return next({ path: '/' })
      }
    }

    if (isGuestOnly) {
      if (user) return next({ path: '/dashboard' })
      return next()
    }

    return next()
  } catch (err) {
    console.error('Route guard error:', err)
    return next({ path: '/login' })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js